var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"slogan"},[_c('div',{staticClass:"content-center"},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("易隆创始终致力于以技术创新为核心驱动，")]),_c('span',[_vm._v("     通过跨组织高效协同，实现客户、伙伴与企业的共赢发展。")])])])])
}]

export { render, staticRenderFns }